module.exports = __webpack_public_path__ + "static/media/branding-img26.e45622dd.jpg";